module.exports = __webpack_public_path__ + "static/2-1f9ec7fabfbcdcb21173301737218f42.jpg";